import axiosPrivateMl from "@services/axiosPrivateMl"
import { GET_SYNCED_FOLDER_IDS, GET_FOLDERS_FROM_GOOGLE_DRIVE } from "../../constants"

export const getSyncedFolderIds = (data) => {
  return axiosPrivateMl.post(GET_SYNCED_FOLDER_IDS, data)
}

export const getFoldersFromGoogleDrive = (googleDriveLink) => {
  return axiosPrivateMl.post(GET_FOLDERS_FROM_GOOGLE_DRIVE, {googleDriveLink})
}